<template>
  <div id="app">
    <router-view></router-view>
    <CustomerServiceFab />
  </div>
</template>

<script>
import CustomerServiceFab from '@/components/CustomerServiceFab.vue';

export default {
  name: "App",
  components: {
    CustomerServiceFab,
  },
  computed: {
   
  },
  mounted() {
  },
};
</script>

<style lang="less">
@import "@/assets/style/iconfont.css";
#app {
  max-width: 750px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: var(--brand-page-bg);
}

* {
  box-sizing: border-box;
}
</style>
